import { Box, Typography, Collapse } from '@mui/material';
import { useState } from 'react';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import PropTypes from 'prop-types';

export default function StreamingFunctionSection() {
  const [open, setOpen] = useState(true);

  const functions = [
    { label: 'Filter Events', functionType: 'FilterEvents' },
    { label: 'User Events', functionType: 'UserEvents' },
    { label: 'Data Transformation', functionType: 'DataTransformation' },
    { label: 'Event Aggregation', functionType: 'EventAggregation' },
  ];

  return (
    <Box>
      {/* Streaming Function Header */}
      <Box
        onClick={() => setOpen(!open)}
        sx={{
          background: 'linear-gradient(100.009deg, rgb(232, 250, 244) 10.544%, rgba(232, 250, 244, 0.2) 149%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: 0.75,
          py: 0.5,
          cursor: 'pointer',
          mb: open ? 3 : 0
        }}
      >
        <Typography
          sx={{
            fontFamily: 'IBM Plex Sans, sans-serif',
            fontWeight: 500,
            fontSize: '0.9375rem',
            color: '#525252',
          }}
        >
          Streaming Function
        </Typography>
        <KeyboardArrowUpIcon 
          sx={{ 
            fontSize: 18, 
            color: '#525252',
            transform: open ? 'none' : 'rotate(180deg)',
            transition: 'transform 0.2s'
          }} 
        />
      </Box>

      {/* Streaming Function Content */}
      <Collapse in={open}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {functions.map((func) => (
            <StreamingFunctionItem
              key={func.functionType}
              label={func.label}
              functionType={func.functionType}
            />
          ))}
        </Box>
      </Collapse>
    </Box>
  );
}

function StreamingFunctionItem({ label, functionType }) {
  const handleDragStart = (e) => {
    e.dataTransfer.setData('application/reactflow', 'Function');
    e.dataTransfer.setData('nodeType', 'Function');
    e.dataTransfer.setData('streamingFunction', functionType);
    e.dataTransfer.effectAllowed = 'move';
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        px: 1.5,
        py: 1,
        borderRadius: '4px',
        cursor: 'grab',
        transition: 'background-color 0.2s',
        '&:hover': {
          backgroundColor: '#F5F5F5',
        },
        '&:active': {
          cursor: 'grabbing',
        },
      }}
      draggable
      onDragStart={handleDragStart}
    >
      <Typography
        sx={{
          fontFamily: 'IBM Plex Sans, sans-serif',
          fontWeight: 400,
          fontSize: '0.875rem',
          color: '#525252',
          lineHeight: 1.4,
        }}
      >
        {label}
      </Typography>
    </Box>
  );
}

StreamingFunctionItem.propTypes = {
  label: PropTypes.string.isRequired,
  functionType: PropTypes.string.isRequired,
};
